if (!customElements.get("el-nothing-hide")) {
  customElements.define(
    "el-nothing-hide",
    class ElNothingHide extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === "true") return;
        this.dataset.ready = "true";

        this.openButton = this.querySelector("[data-nothing-hide-open]");
        this.modal = this.querySelector("[data-nothing-hide-modal]");
        this.closeButtons = Array.from(
          this.querySelectorAll("[data-nothing-hide-close]"),
        );
        this.scrollArea = this.querySelector("[data-nothing-hide-scroll]");
        this.progressBar = this.querySelector("[data-nothing-hide-progress]");

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.updateProgress = this.updateProgress.bind(this);

        if (this.openButton) {
          this.openButton.addEventListener("click", this.openModal);
        }

        this.closeButtons.forEach((button) => {
          button.addEventListener("click", this.closeModal);
        });

        if (this.scrollArea) {
          this.scrollArea.addEventListener("scroll", this.updateProgress, {
            passive: true,
          });
        }
      }

      disconnectedCallback() {
        if (this.openButton) {
          this.openButton.removeEventListener("click", this.openModal);
        }

        this.closeButtons.forEach((button) => {
          button.removeEventListener("click", this.closeModal);
        });

        if (this.scrollArea) {
          this.scrollArea.removeEventListener("scroll", this.updateProgress);
        }

        document.removeEventListener("keydown", this.handleKeydown);
      }

      openModal() {
        if (!this.modal) return;

        this.modal.classList.add("is-active");
        this.modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("el-nothing-hide-lock");
        document.addEventListener("keydown", this.handleKeydown);

        requestAnimationFrame(() => {
          if (this.scrollArea) {
            this.scrollArea.scrollLeft = 0;
          }

          this.updateProgress();
        });
      }

      closeModal() {
        if (!this.modal) return;

        this.modal.classList.remove("is-active");
        this.modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("el-nothing-hide-lock");
        document.removeEventListener("keydown", this.handleKeydown);
      }

      handleKeydown(event) {
        if (event.key === "Escape") {
          this.closeModal();
        }
      }

      updateProgress() {
        if (!this.scrollArea || !this.progressBar) return;

        const maxScroll =
          this.scrollArea.scrollWidth - this.scrollArea.clientWidth;

        if (maxScroll <= 0) {
          this.progressBar.style.width = "100%";
          return;
        }

        const progress = (this.scrollArea.scrollLeft / maxScroll) * 100;
        this.progressBar.style.width = `${Math.max(8, progress)}%`;
      }
    },
  );
}
